import React from 'react';

import {Link} from '../../../../lib/routes';

type Props = {
	args: string[];
};

// {@bookChapter PaBTSO, PaBTSO-04, Глава 3}
export const BookChapterPlugin: React.FC<Props> = ({args}) => {
	const [bookId, chapterId, ...rest] = args;
	const title = rest.join(', ') || chapterId;

	return (
		<Link route={'bookChapter'} params={{bookId, chapterId}} title={title}>
			{title}
		</Link>
	);
};
